module.exports = __webpack_public_path__ + "static/media/download-pdf.f3510a26.svg";